import menunav from "./mens";
const isMOBILE = function () {
	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
	)
	return flag
}

const models =  [
	{
		path: '/',
		redirect:  isMOBILE() ? '/login' : 'PCLogin'
	},
	{
		name: 'introPage',
		path: '/introPage',
		component: () => import('@/view/introPage'),
		meta: {
			title: '首导页'
		}
	},
	{
		name: 'login',
		path: '/login',
		component: () => import('@/view/login'),
		meta: {
			title: '登录页'
		},
	},
	{
		name: 'home',
		path: '/home',
		component: () => import('@/view/home'),
		meta: {
			title: '首页',
			hasFooter: true
		},

		beforeEnter: (to, from, next) => {
			if(JSON.parse(localStorage.getItem("user"))){
				if (JSON.parse(localStorage.getItem("user")).isProperty == 0) {
					next({
						path: '/home2'
					})
				} else {
					next()
				}
			}else{
				next()
			}
		}
	},
	{
		name: 'home2',
		path: '/home2',
		component: () => import('@/view/home/studentIndex.vue'),
		meta: {
			title: '首页',
			hasFooter: true
		},
		beforeEnter: (to, from, next) => {
			if(JSON.parse(localStorage.getItem("user"))){
				if (JSON.parse(localStorage.getItem("user")).isProperty == 0) {
					next({
						path: '/home'
					})
				} else {
					next()
				}
			}else{
				next()
			}
		}
	},
	{
		name:'openClass',
		path:'/openClass',
		component: () => import('@/view/openClass'),
		meta: {
			title: '公开课',
			hasFooter: true
		},
	},
	{
		name: 'five',
		path: '/five',
		component: () => import('@/view/five'),
		meta: {
			title: '500'
		}
	},
	{
		name: 'personal',
		path: '/personal',
		component: () => import('@/view/personal'),
		meta: {
			title: '个人信息',
			hasFooter: true
		}
	},
	{
		name: 'details',
		path: '/details',
		component: () => import('@/view/Details'),
		meta: {
			title: '课程详情',
			// hasFooter: true
		},
		beforeEnter: (to, from, next) => {
			if (JSON.parse(localStorage.getItem("user")).isProperty == 0) {
				next({
					path: '/studentdetails'
				})
			} else {
				next()
			}
		}
	},
	{
		name: 'studentdetails',
		path: '/studentdetails',
		component: () => import('@/view/Details/studentIndex'),
		meta: {
			title: '课程详情',
		},
		beforeEnter: (to, from, next) => {
			if (JSON.parse(localStorage.getItem("user")).isProperty == 1) {
				next({
					path: '/details'
				})
			} else {
				next()
			}
		}
	},
	{
		name: 'MyCollection',
		path: '/MyCollection',
		component: () => import('@/view/MyCollection'),
		meta: {
			title: '我的收藏',
			// hasFooter: true
		}
	},
	{
		name: 'evaluationDetails',
		path: '/evaluationDetails',
		component: () => import('@/view/evaluationDetails'),
		meta: {
			title: '用户协议',
			// hasFooter: true
		}
	},
	{
		name: 'userAfreement',
		path: '/userAfreement',
		component: () => import('@/view/agreement/userAfreement.vue'),
		meta: {
			title: '用户协议',
			// hasFooter: true
		}
	},
	{
		name: 'PrivacyAgreement',
		path: '/PrivacyAgreement',
		component: () => import('@/view/agreement/PrivacyAgreement.vue'),
		meta: {
			title: '隐私协议',
			// hasFooter: true
		}
	},
	{
		name: 'changePassword',
		path: '/changePassword',
		component: () => import('@/view/password/index.vue'),
		meta: {
			title: '修改密码',
			// hasFooter: true
		}
	},
	{
		name: 'aboutUs',
		path: '/aboutUs',
		component: () => import('@/view/AboutUs/index.vue'),
		meta: {
			title: '关于我们',
			// hasFooter: true
		}
	},
	...menunav
]

export default models